import React, { useState } from 'react'
import QuizCompo from './QuizCompo'

const Scoreboard = (props) => {
    const [back,setBack] =useState(false)
    const handleClick=()=>{
        console.log("clicked")
       setBack(true)
    }
    if(!back){
  return (
    <div className='scoreboard'>
        <div>congrats!</div><br/>
        <div>You Scored : {props.name} / {props.ques}</div>
        <button className='back' onClick={handleClick}>Test Again</button>
        </div>
  )
    }else{
        return(<QuizCompo/>)
    }
}

export default Scoreboard